// extracted by mini-css-extract-plugin
export default {"card-header":"modal_card-header__hdvph","modalWrapper":"modal_modalWrapper__V7tsR","modalHeader":"modal_modalHeader__caqJK","modalTitle":"modal_modalTitle__5zexv"};